import { Component, Input, Optional, Self } from "@angular/core";
import { NG_VALIDATORS, NgControl } from "@angular/forms";
import { FormControlBase } from "../../common/form-control-base/form-control-base";
import { TCMEmailValidator } from "../../validators/email";

export let wafEmailValidator = new TCMEmailValidator();
@Component({
    selector: 'waf-email-input',
    templateUrl: './email-input.component.html',
    inputs: ['label', 'disabled', 'hideValidationMessages', 'isReadonlyValue', 'placeholder', 'tabindex'],
    providers: [
        { provide: NG_VALIDATORS, useValue: wafEmailValidator, multi: true }
    ],
    standalone: false
})
export class EmailInputComponent extends FormControlBase<string> {
  constructor(@Self() @Optional() protected override ngModel: NgControl) {
      super('waf-email-input', ngModel);
  }

  @Input()
  public maxLength: number = 255;
}